enum ActionType {
    REQUEST_LOCATION_TAG_THREAT_SCORE = '[DASHBOARD/LOCATION_TAG_THREAT_SCORE] GET LOCATION TAG THREAT SCORE',
    RECEIVE_LOCATION_TAG_THREAT_SCORE = '[DASHBOARD/LOCATION_TAG_THREAT_SCORE] SET LOCATION TAG THREAT SCORE',
    LOCATION_TAG_THREAT_SCORE_REQUEST_FAILED = '[DASHBOARD/LOCATION_TAG_THREAT_SCORE] LOCATION TAG THREAT SCORE REQUEST FAILED',
}

export default ActionType
